import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'modeThirdNana';
const args = {};

export class ModeThirdNana extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
